import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {ConfirmationModal, OverlayTooltip} from "../../components";
import {Button, Form} from 'react-bootstrap';
import {ToastError} from "../../utils/toastUtil";
import {toast} from 'react-toastify';
import {startVectorizationProcess} from "../../services/vectorization/vectorizationProcess";
import {useLoadOptions} from "../../hooks/useLoadOptions";
import {useAuthorization} from "../../hooks";

interface IConfirmationModalProps {
    uploadedFile: File;
}

const StartVectorization: React.FC<IConfirmationModalProps> = ({uploadedFile}) => {
    const {t} = useTranslation();
    const {presetOptions} = useLoadOptions();
    const [isShowConfirmationModal, setIsShowConfirmationModal] = useState(false);
    const [selectedPresets, setSelectedPresets] = useState<number[]>([0]);
    const [isLoading, setIsLoading] = useState(false);
    const {hasVectorizationPermission} = useAuthorization();

    const handleCheckboxChange = (id: number) => {
        setSelectedPresets([id])
    };

    const handleConfirmVectorization = async () => {
        try {
            setIsLoading(true);
            const response = await startVectorizationProcess(uploadedFile, selectedPresets);
            if (response) {
                toast.success(
                    <span>{t("Vectorization.SuccessMessage").replace("{link}", "")}
                        <a href="/vectorization">{t("Vectorization.LinkText")}</a></span>,
                    {
                        closeOnClick: false,
                    }
                );
            }
        } catch (error) {
            ToastError(error as string);
        } finally {
            setIsLoading(false);
            setIsShowConfirmationModal(false);
        }
    };
    return (
        hasVectorizationPermission && (
            <div className="d-flex justify-content-end">
                <div className="d-flex flex-row gap-2 align-items-center">
                    <Button
                        variant="secondary"
                        onClick={() => setIsShowConfirmationModal(true)}
                        style={{ marginBottom: "10px" }}
                    >
                        {t("Vectorization.Start")}
                    </Button>
                </div>

                <ConfirmationModal
                    isDisableConfirm={selectedPresets.length === 0}
                    show={isShowConfirmationModal}
                    isLoading={isLoading}
                    title={t("Vectorization.ConfirmationTitle")}
                    body={
                        <Form>
                            {Object.keys(presetOptions).map((key: string) => (
                                <div key={key} className="d-flex flex-row gap-2 justify-content-between">
                                    <Form.Check
                                        type="radio"
                                        id={`checkbox-${Number(key)}`}
                                        label={presetOptions[Number(key)].label}
                                        checked={selectedPresets.includes(Number(key))}
                                        onChange={() => handleCheckboxChange(Number(key))}
                                    />
                                    <OverlayTooltip tooltipContent={presetOptions[Number(key)].tooltip} placement="right" />
                                </div>
                            ))}
                        </Form>
                    }
                    onConfirm={handleConfirmVectorization}
                    onCancel={() => setIsShowConfirmationModal(false)}
                />
            </div>
        )
    );
};

export default StartVectorization;
